export const REDEMPTION_ENDPOINT = '/v1/profiles/me/webservices/redeemCode';
export const SET_REDEMPTION_STATUS_FETCHING = 'SET_REDEMPTION_STATUS_FETCHING' as const;
export const SET_REDEMPTION_STATUS = 'SET_REDEMPTION_STATUS' as const;
export const REMOVE_REDEMPTION_STATUS = 'REMOVE_REDEMPTION_STATUS' as const;
export const SET_REDEMPTION_CODE = 'SET_REDEMPTION_CODE' as const;
export const SET_REDEEM_DATA = 'SET_REDEEM_DATA' as const;
export const RECYCLE_REDEMPTION_PROCESS = 'RECYCLE_REDEMPTION_PROCESS' as const;
export const SET_REDEMPTION_PLATFORM_TYPE = 'SET_REDEMPTION_PLATFORM_TYPE' as const;

export const enum REDEMPTION_STATUS {
    SUCCESS = 'SUCCESS',
    GENERIC_ERROR = 'GENERIC_ERROR',
    INVALID_CODE = 'INVALID_CODE',
    CODE_ALREADY_REDEEMED = 'CODE_ALREADY_REDEEMED',
    USER_ALREADY_REDEEMED = 'USER_ALREADY_REDEEMED',
    NOT_ELIGIBLE = 'NOT_ELIGIBLE_BY_COUNTRY',
    AGE_RESTRICTION = 'AGE_RESTRICTION',
    ADDITIONAL_INFO = 'REQUIRE_ADDITIONAL_INFO',
    SELECT_BENEFIT_REQUIRED = 'SELECT_BENEFIT_REQUIRED',
    PROFILE_NOT_LINKED = 'PROFILE_NOT_LINKED',
    MAINTENANCE_ERROR = 'MAINTENANCE_ERROR'
}

export const REDEMPTION_RESPONSE_CODES = {
    SUCCESS: 200000,
    INVALID_CODE: 400101,
    CODE_ALREADY_REDEEMED: 400105,
    USER_ALREADY_REDEEMED: 400106,
    NOT_ELIGIBLE: 400108, // user country restricted,
    AGE_RESTRICTION: 400114, // not compliant with age rating
    ADDITIONAL_INFO: 400107,
    PROFILE_NOT_LINKED: 400112,
    PROFILE_NOT_AVAILABLE: 400110
};

export const REDEMPTION_CONTENT_STATUSES = {
    PENDING: 'PENDING_DELIVERY',
    REDEEMED_NOT_ACTIVATED: 'REDEEMED_NOT_ACTIVATED',
    REDEEMED_AND_DELIVERED: 'REDEEMED_AND_DELIVERED'
};

export const REDEMPTION_RESPONSE_CONTEXTS = {
    CODE: 'code',
    USER_IP: 'User-IP'
};

export const TEXT_KEYS = {
    UNLOCK_YOUR_CONTENT: 'content__event-title',
    REDEEM_SUCCESS_MAIN_TITLE: 'redeem-success__main-title',
    REDEEM_SUCCESS_MULTIPLE_REWARDS: 'redeem-success__multiple-rewards',
    REDEEM_SUCCESS_GIFT_DESCRIPTION: 'redeem-success__gift-description',
    REDEEM_SUCCESS_CONGRATS_MESSAGE_SINGLE_ITEM: 'redeem-success__congratulation-message-single',
    REDEEM_SUCCESS_CONGRATS_MESSAGE_MULTIPLE_ITEMS: 'redeem-success__congratulation-message-multiple',
    REDEEM_SUCCESS_TITLE: 'redeem-success__title',
    REDEEM_SUCCESS_CONGRATS_V1_MESSAGE: 'redeem-success__v1__message',
    REDEEM_EXPLANATION: 'redeem-success__explanation',
    BETA_ACCESS: 'redeem-success__gift-beta-access',
    SECONDARY_STORE_DELIVERED: 'redeem-success__gift-secondary-store__delivered',
    SECONDARY_STORE_NOT_ACTIVATED: 'redeem-success__gift-secondary-store__not-activated',
    GENERAL_KEY_DISTRIBUTION_NO_KEY: 'redeem-success__gift-key-distribution__not-activated__no-key',
    PC_KEY_DISTRIBUTION_DELIVERED: 'redeem-success__gift-key-distribution__delivered__pc',
    PC_KEY_DISTRIBUTION_NOT_ACTIVATED_KEY: 'redeem-success__gift-key-distribution__not-activated__pc__key',
    CONSOLE_KEY_DISTRIBUTION_DELIVERED_OR_NOT_ACTIVATED: 'redeem-success__gift-key-distribution__not-activated__console__key',
    CONSOLE_KEY_DISTRIBUTION_NOT_ACTIVATED_NO_KEY: 'redeem-success__gift-key-distribution__not-activated__console__no-key',
    CLUB_REWARD_DELIVERED: 'redeem-success__gift-club-reward__delivered',
    CLUB_REWARD_NOT_ACTIVATED: 'redeem-success__gift-club-reward__not-activated'
};

export const ERROR_TEXT_KEYS = {
    ERROR_NOT_ELIGIBLE: 'redeem-error__not-eligible',
    ERROR_REQUIREMENTS_NOT_MET: 'redeem-error__requirements-not-met',
    ERROR_MAINTENANCE: 'redeem-error__campaign-status-maintenance',
    ERROR_CODE_ALREADY_REDEEMED: 'redeem-error__code-already-redeemed',
    ERROR_USER_ALREADY_REDEEMED: 'redeem-error__user-already-redeemed',
    ERROR_INVALID_CODE: 'redeem-error__invalid-code',
    ERROR_PROFILE_NOT_LINKED: 'redeem-error__stadia-not-linked',
    SUPPORT: 'support-text-no-faq',
    SUPPORT_FAQ: 'support-text'
};
